module.exports = __webpack_public_path__ + "sim1.8d6f30f8.png";